module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Schmerikon-fafb5f484f40d35f729e0573f607dedb.svg";